import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "src/common/utils/i18n.js";
import { useProfilePreference } from "./useProfilePreference.js";

export const isValidLanguage = (value: unknown): value is string =>
	typeof value === "string" &&
	LANGUAGES.some((language) => language.code === value);

/** Single write path for the language preference — applies immediately via i18next, persists local-first + debounced remote sync. */
export const useLanguagePreference = () => {
	const { i18n } = useTranslation();
	const [, setStoredLanguage] = useProfilePreference("language", i18n.language);

	const changeLanguage = useCallback(
		(code: string) => {
			void i18n.changeLanguage(code);
			setStoredLanguage(code);
		},
		[i18n, setStoredLanguage],
	);

	return useMemo(
		() => ({ language: i18n.language, changeLanguage }),
		[i18n.language, changeLanguage],
	);
};
